import React, { useContext } from "react";
import "./accountLanguage.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import ReactCountryFlag from "react-country-flag";

const AccountLanguage = () => {
    const { language, setLanguage } = useContext(CombinedContext);

    return (
        <div className="sf-account-language-page">
            <h2 className="sf-account-language-title">
                {translations[language].account.language.title}
            </h2>

            <div className="sf-account-language-options">
                <button
                    className={`sf-account-language-option ${
                        language === "en" ? "active" : ""
                    }`}
                    onClick={() => setLanguage("en")}
                >
                    <ReactCountryFlag countryCode="CA" svg />
                    <span>English</span>
                </button>

                <button
                    className={`sf-account-language-option ${
                        language === "es" ? "active" : ""
                    }`}
                    onClick={() => setLanguage("es")}
                >
                    <ReactCountryFlag countryCode="DO" svg />
                    <span>Español</span>
                </button>
            </div>
        </div>
    );
};

export default AccountLanguage;
